/* jshint ignore:start */
"use strict";
// DO NOT EDIT THIS FILE, EDIT THE GULP TASK SETTINGS INSTEAD WHICH GENERATES THIS FILE
angular.module("oqs")

.constant("ENV", "prod")

;
/* jshint ignore:end */